import { Link } from "react-router-dom";
import {
  formatWeekRange,
  isThisWeek,
  shiftWeek,
  thisMondayIso,
} from "../lib/week";

interface WeekNavigatorProps {
  /** Current week-start ISO (Monday). */
  weekStartIso: string;
  /** Base path — the nav links will point to `${basePath}/<iso>`. */
  basePath: string;
}

/**
 * Prev / date-range / Next row for weekly pages. Mirrors the existing
 * Maison visual language: label-style links, hairline framing.
 */
export function WeekNavigator({ weekStartIso, basePath }: WeekNavigatorProps) {
  const prevIso = shiftWeek(weekStartIso, -1);
  const nextIso = shiftWeek(weekStartIso, 1);
  const atThisWeek = isThisWeek(weekStartIso);

  return (
    <div className="flex flex-wrap items-center justify-between gap-6">
      <Link
        to={`${basePath}/${prevIso}`}
        className="label ink-link text-ink-walnut"
        aria-label="Previous week"
      >
        ← Previous week
      </Link>

      <div className="flex flex-col items-center text-center">
        <div className="label text-sienna">The week of</div>
        <div className="mt-1 font-display text-3xl font-light leading-none text-ink md:text-4xl">
          {formatWeekRange(weekStartIso)}
        </div>
        {!atThisWeek && (
          <Link
            to={`${basePath}/${thisMondayIso()}`}
            className="label ink-link mt-3 text-ink-walnut"
          >
            Return to this week
          </Link>
        )}
      </div>

      <Link
        to={`${basePath}/${nextIso}`}
        className="label ink-link text-ink-walnut"
        aria-label="Next week"
      >
        Next week →
      </Link>
    </div>
  );
}
